import React, { useEffect, useState } from "react";
import { IoIosArrowForward, IoMdCheckmarkCircleOutline } from "react-icons/io";
import CircularProgress from "@mui/material/CircularProgress";
import "./Billing.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { programActions } from "../../../store/reducers/program";
import BillingModal from "../../Modals/billing-modal";
import CustomEnrollNowButton from "../CustomEnrollNowButton";

const Billing = () => {
  const { data, enrollLoderState } = useSelector((state) => state.program);
  const dispatch = useDispatch();
  const [billings, setBillings] = useState(null);

  const [smallestEmi, setSmallestEmi] = useState(0);

  useEffect(() => {
    if (data?.billing) {
      setSmallestEmi(
        Math.min(
          ...data?.billing.monthly_emi.map((item) => item.emi)
        ).toLocaleString("en-IN")
      );
    }
  }, [data?.billing]);

  const handleEnrollNow = () => {
    if (data) {
      dispatch(programActions.setEnrollState(data));
    }
  };

  const handleBillingsOpen = () => {
    if (data) {
      setBillings(data?.billing);
    }
  };

  return (
    <div
      id="program fee"
      className="billing w-full flex justify-center py-6 md:py-12 xl:px-12 px-4"
    >
      <div className="w-full max-w-[85rem]">
        <div className="w-full md:text-start text-center">
          <h4 className="text-base font-medium">Make Your Investment Count!</h4>
          <h1 className="text-2xl md:text-3xl mt-2 font-semibold capitalize">
            Program <span className="text-universal">Fees</span> and Highlights:
            An Overview
          </h1>
        </div>
        <div className="w-full flex max-md:items-center gap-4 lg:flex-row flex-col md:gap-8 mt-8 md:mt-12">
          <div className="w-full lg:max-w-sm border border-neutral-300 rounded-xl bg-white px-6 py-6">
            <h1 className="text-lg md:text-xl font-semibold">
              Key Program Highlights
            </h1>
            <div className="w-full mt-4 flex flex-col gap-3 md:gap-4">
              {data?.billing?.points.map((point, index) => (
                <div key={index} className="w-full flex gap-4 items-start">
                  <div className="md:w-6 md:h-6 h-5 w-5 flex-shrink-0 mt-[2px]">
                    <IoMdCheckmarkCircleOutline className="w-full h-full text-green-500" />
                  </div>
                  <h1 className="text-base md:text-lg font-medium">{point}</h1>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 flex flex-col gap-4">
            <div className="billing-grad w-full border overflow-hidden bg-universal rounded-xl flex items-center justify-between md:flex-row flex-col p-2 md:p-[2px]">
              <div className="w-full md:flex-[0.6] bg-white md:text-start text-center py-12 md:py-16 px-6 md:px-12 rounded-xl border border-universal">
                <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold ">
                  Starts at Just &#x20B9; {smallestEmi}/month
                </h1>
                <h4 className="text-base md:text-lg mt-2 max-w-xl font-semibold md:font-medium text-neutral-600">
                  Program Fee: &#x20B9;{" "}
                  {data?.billing?.total.toLocaleString("en-IN")} + GST
                </h4>
              </div>
              <div className="w-full md:flex-[0.4] flex items-center justify-center py-8 md:py-16 px-4 rounded-xl">
                {data?.enrollments === "active" ? (
                  <>
                    {enrollLoderState ? (
                      <button
                        disabled={enrollLoderState}
                        //  onClick={handleEnrollNow}
                        className="text-nowrap w-full max-w-[250px] px-4 py-3 mt-4 rounded-lg text-blue-500 bg-white text-xl font-semibold flex items-center justify-center gap-1"
                      >
                        <CircularProgress
                          size={15}
                          sx={{ color: "#1A73E8" }} // Set spinner color to white
                        />
                      </button>
                    ) : (
                      <CustomEnrollNowButton
                        data={data}
                        text={"Apply Now"}
                        className={
                          "text-nowrap w-full max-w-[250px] px-4 py-3 mt-4 rounded-lg text-blue-500 bg-white text-xl font-semibold flex items-center justify-center gap-1"
                        }
                      />
                    )}
                  </>
                ) : (
                  // <CustomEnrollNowButton
                  //   arrowVisible={true}
                  //   text={"Apply Now"}
                  //   data={data}
                  // className={
                  //   "text-nowrap w-full max-w-[250px] px-4 py-3 mt-4 rounded-lg text-blue-500 bg-white text-xl font-semibold flex items-center justify-center gap-1"
                  // }
                  // />
                  <>
                    {data?.enrollments === "coming-soon" ? (
                      <button className="text-nowrap w-full max-w-[200px] px-4 py-3 mt-4 rounded-lg text-blue-500 bg-white text-xl font-semibold flex items-center justify-center gap-1 cursor-not-allowed">
                        Coming Soon
                      </button>
                    ) : (
                      <button className="text-nowrap w-full max-w-[200px] px-4 py-3 mt-4 rounded-lg text-blue-500 bg-white text-xl font-semibold flex items-center justify-center gap-1 cursor-not-allowed">
                        Admission closed
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="border border-neutral-300 w-full py-6 md:py-16 px-6 md:px-12 rounded-xl flex items-center justify-between md:flex-row flex-col gap-6">
              <div className="md:text-start text-center">
                <h1 className="text-xl md:text-2xl font-semibold text-slate-800">
                  Are you ready to embark on a journey of growth and
                  transformation? Start today!
                </h1>
                <h4 className="text-base md:text-lg mt-4 max-w-xl font-medium text-neutral-500 max-md:hidden">
                  Limited Spots Available: Apply Now and Take the First Step
                </h4>
              </div>
              <button
                onClick={handleBillingsOpen}
                className="w-full max-w-[200px] px-4 py-3 mt-4 rounded-lg text-universal transition-all duration-150 hover:bg-universal/10 text-base md:text-lg font-medium flex items-center justify-center gap-1 border border-blue-100"
              >
                View all Plans
              </button>
            </div>
          </div>
        </div>
      </div>
      <BillingModal open={billings} setOpen={setBillings} />
    </div>
  );
};

export default Billing;
